import PaginationItem from "@mui/material/PaginationItem";
import { Pagination as MuiPagination } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const Pagination = ({ pageSize, offset, count, onChange }) => {
  const getPageCount = () => Math.ceil(count / pageSize);
  const getCurrentPage = () => Math.ceil((offset + 1) / pageSize);
  const changeHandler = (e, p) => {
    onChange(p);
    // window.scrollTo({
    //   top: 0,
    //   behavior: "smooth",
    // });
    e.stopPropagation();
  };
  const theme = createTheme({ direction: "rtl" });
  return (
    <div className="pagination-box" dir="rtl">
      {count > pageSize && (
        <ThemeProvider theme={theme}>
          <MuiPagination
            count={getPageCount()}
            onChange={changeHandler}
            page={getCurrentPage()}
            color="primary"
            renderItem={(item) => <PaginationItem {...item} />}
          />
        </ThemeProvider>
      )}
    </div>
  );
};

export default Pagination;
